import { useState } from "react";
import { Wrench, MagnifyingGlass } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("es-ES", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—");

export default function FixIncidenceTz() {
  const [report, setReport] = useState(null);
  const [busy, setBusy] = useState(false);

  const run = async (apply) => {
    if (apply && !window.confirm(`Se corregirán ${report.changed} fichaje(s). ¿Continuar?`)) return;
    setBusy(true);
    try {
      const { data } = await api.post("/admin/fix-incidence-tz", { apply });
      setReport(data);
      if (apply) toast.success(`${data.changed} fichaje(s) corregidos`);
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };

  return (
    <div className="card-flat p-6 space-y-3" data-testid="fix-tz-card">
      <div className="label-cap">mantenimiento · corregir horarios</div>
      <p className="text-sm text-[var(--text-secondary)]">
        Corrige la hora de los fichajes creados por incidencias antiguas que se guardaron con la zona horaria equivocada. Primero simula y revisa; luego aplica.
      </p>
      <div className="flex gap-2 flex-wrap">
        <button type="button" onClick={() => run(false)} disabled={busy} data-testid="fix-tz-simulate" className="px-4 py-2 rounded-xl border border-[var(--border)] bg-white font-display font-semibold inline-flex items-center gap-2 hover:bg-[var(--bg)] disabled:opacity-50">
          <MagnifyingGlass size={16} /> Simular
        </button>
        {report && !report.applied && report.changed > 0 && (
          <button type="button" onClick={() => run(true)} disabled={busy} data-testid="fix-tz-apply" className="btn-danger px-4 py-2 rounded-xl font-display font-bold inline-flex items-center gap-2 disabled:opacity-50">
            <Wrench size={16} /> Aplicar cambios ({report.changed})
          </button>
        )}
      </div>
      {report && (
        <div className="text-sm" data-testid="fix-tz-report">
          <div className="font-display font-semibold mb-2">
            {report.applied ? "Aplicado" : "Simulación"}: {report.changed} de {report.total} fichaje(s) de incidencia {report.applied ? "corregidos" : "cambiarían"}.
          </div>
          {report.changes.length > 0 && (
            <ul className="max-h-60 overflow-auto space-y-1 font-mono text-xs">
              {report.changes.map((c) => (
                <li key={c.punch_id} className="p-2 rounded-lg bg-[var(--bg)]">
                  {c.date}: {fmt(c.from_start)} → {fmt(c.to_start)} · {fmt(c.from_end)} → {fmt(c.to_end)}
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
